import { SupplyShedFiltersContext } from '../context/SupplyShedFiltersContext'
import { useContext } from 'react'

export const useSupplyShedFilters = () => {
  const context = useContext(SupplyShedFiltersContext)
  return context
}
